import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import _ from "lodash";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import styles from "./dealerExportForm.module.scss";
import CheckboxGroup from "../../../components/checkBoxGroupComponent/CheckboxGroup";
import Button from "../../../components/buttons/Buttons";
import i18next from "i18next";
import FormikControl from "../../../components/formComponents/FormikControl";
import {
  dateFormats,
  dateInputValidation,
  generalValidationMessage,
  downloadCsv,
  StatusEnumValue,
} from "../../../config/appConfig";
import {
  exportDealer,
  getGroupDropdownOptions,
  getProvinceList,
} from "../../../services/APIService";
import { useApiErrorModalContext } from "../../../errorHandling/ApiErrorModalContext";

const DealerExportForm = () => {
  let defaultInitialValue = {
    toDate: "",
    fromeDate: "",
    groupList: [],
    provinceList: [],
    providerList: {},
    dealerStatus: [],
  };
  const { setApiErrorModalState } = useApiErrorModalContext();
  const [provinceListApiRes, setProvinceListApiRes] = useState([]);
  const [groupListRes, setGroupListRes] = useState([]);
  const hasErrorCheck = (touched, errors, name) => {
    return !!(touched[name] && errors[name]);
  };
  useEffect(() => {
    getProvinceList()
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setProvinceListApiRes(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    getGroupDropdownOptions()
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setGroupListRes(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initalValue = defaultInitialValue;
  const translatedGeneralValidationMessage = `${i18next.t(
    generalValidationMessage
  )}`;
  const validationSchema = Yup.object().shape({
    toDate: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
    fromeDate: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
  });

  const statusList = ["All", "Ja", "Nee", "Prospect", "Wachtruimte"];

  const providerLabelList = ["All", "RDC", "VWE", "ASP", "MOX",  "PR5", "PR6", "Onbekend"];
  const handleCheckBoxChange = (
    event,
    optionList,
    setFieldValue,
    fieldName,
    valueList
  ) => {
    let value = {};

    if (event.target?.name === "All") {
      if (event.target.checked === true) {
        valueList.map((field) => {
          value = { ...value, ...{ [field]: true } };          
          return value;
        });
      } else {
        valueList.map((value) => {
          value = { ...value, ...{ [value]: false } };
          return value;
        });
      }
    } else {
      value = {
        ...optionList,
        [event.target?.name]: event.target?.checked,
      };
      let allChecked = Object.keys(value).filter(
        (field) => value[field] && field !== "All"
      );
      if (allChecked.length !== valueList.length - 1) {
        value = { ...value, ...{ All: false } };
      } else {
        value = { ...value, ...{ All: true } };
      }
    }

    setFieldValue(fieldName, value);
  };

  const handleDownload = (values) => {
    if (_.isEmpty(values.fromeDate) || _.isEmpty(values.toDate)) {
      return;
    }
    let province = _.get(values, "provinceList", []).map(
      (province) => province?.value
    );
    let dealer_Status = Object.keys(
      _.pickBy(_.get(values, "dealerStatus", {}))
    );

    if (_.includes(dealer_Status, "All")) {
      dealer_Status = [100];
    } else {
      dealer_Status = dealer_Status.map((status) => StatusEnumValue[status]);
    }
    let providers = Object.keys(_.pickBy(_.get(values, "providerList", {})));
    if (_.includes(providers, "All")) {
      providers = null;
    }
    let groupIds = _.get(values, "groupList", []).map(
      (group) => group.dealergroup_Id
    );

    exportDealer({
      ...values,
      ...{
        province: _.isEmpty(province) ? [0] : province,
        dealer_Status: _.isEmpty(dealer_Status) ? [100] : dealer_Status,
        providers: _.isEmpty(providers) ? null : providers,
        groupIds: _.isEmpty(groupIds) ? [0] : groupIds,
      },
    })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          downloadCsv(response.fileData, response.fileName);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };
  const getUpdatedDropdownValue = (values, value, fieldName, responseValue) => {
    let keyArrayItems = value?.map((item) => item.key);
    if (
      _.includes(keyArrayItems, "Select All") &&
      values[fieldName].length === responseValue.length
    ) {
      value = [];
    } else if (
      _.includes(keyArrayItems, "Select All") &&
      values[fieldName].length !== responseValue.length
    ) {
      value = responseValue;
    }
      return value;

  };
  return (
    <Box
      className={styles.dealerExportFormWrapper}
      data-testid="DealerExportForm"
    >
      <Formik
        initialValues={initalValue}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={(values) => {
          handleDownload(values);
        }}
      >
        {({
          errors,
          touched,
          handleSubmit,
          values,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box className={`formWrapper ${styles.dealerExportFormWrapper}`}>
              <Box className="textboxDoubleWraper">
                <FormikControl
                  variant="filled"
                  control="multiselect"
                  label="Groep"
                  options={groupListRes}
                  hiddenLabel
                  id="multiSelectDropdown"
                  name="groupList"
                  size="small"
                  hasSelectAll={false}
                  noOptionsText={
                    <Box>
                      <Box>{i18next.t("No results found")}</Box>
                    </Box>
                  }
                  isSelect={true}
                  disabled={false}
                  disableCloseOnSelect={true}
                  placeholder={i18next.t("Select dealer group")}
                  className="input-grp__box select"
                  freeSolo={false}
                  hasSubText={true}
                  subTextField={{ title: "key", subText: ["group_email_id"] }}
                  onChange={(e, value) => {
                    setFieldTouched("groupList", false);
                    let updatedValue = getUpdatedDropdownValue(
                      values,
                      value,
                      "groupList",
                      groupListRes
                    );
                   
                    setFieldValue("groupList", updatedValue);
                  }}
                  value={values.groupList}
                  hasError={hasErrorCheck(touched, errors, "groupList")}
                  error={hasErrorCheck(touched, errors, "groupList")}
                  errorMessage={errors?.groupList}
                />
              </Box>
              <Box className={styles.exportCheckBoxGroup}>
                <Box className="input-grp__label">Statussen</Box>
                <CheckboxGroup
                  checkBoxList={statusList}
                  name="dealerStatus"
                  handleChange={(e) =>
                    handleCheckBoxChange(
                      e,
                      values.dealerStatus,
                      setFieldValue,
                      "dealerStatus",
                      statusList
                    )
                  }
                  checkBoxState={values.dealerStatus}
                />
              </Box>
              <Box className={styles.exportCheckBoxGroup}>
                <Box className="input-grp__label">Providers</Box>
                <CheckboxGroup
                  checkBoxList={providerLabelList}
                  name="providerList"
                  handleChange={(e) =>
                    handleCheckBoxChange(
                      e,
                      values.providerList,
                      setFieldValue,
                      "providerList",
                      providerLabelList
                    )
                  }
                  checkBoxState={values.providerList}
                />
              </Box>

              <Box className="textboxDoubleWraper">
                <FormikControl
                  variant="filled"
                  control="multiselect"
                  label="Province"
                  options={provinceListApiRes}
                  hiddenLabel
                  id="multiSelectDropdown"
                  name="provinceList"
                  size="small"
                  hasSelectAll={true}
                  isSelect={true}
                  disabled={false}
                  placeholder={i18next.t("Select province")}
                  className="input-grp__box select"
                  freeSolo={false}
                  disableCloseOnSelect={true}
                  noOptionsText={
                    <Box>
                      <Box>{i18next.t("No results found")}</Box>
                    </Box>
                  }
                  onChange={(e, value) => {
                    setFieldTouched("provinceList", false);

                    let updatedValue = getUpdatedDropdownValue(
                      values,
                      value,
                      "provinceList",
                      provinceListApiRes
                    );

                    setFieldValue("provinceList", updatedValue);
                  }}
                  value={values.provinceList}
                  hasError={hasErrorCheck(touched, errors, "provinceList")}
                  error={hasErrorCheck(touched, errors, "provinceList")}
                  errorMessage={errors?.provinceList}
                />
              </Box>
              <Box className="textboxDoubleWraper">
                <FormikControl
                  variant="filled"
                  control="datepicker"
                  hiddenLabel
                  label={i18next.t("From date")}
                  id="fromeDate"
                  name="fromeDate"
                  value={values.fromeDate}
                  placeholderText={i18next.t("Select From date")}
                  format={"DD-MM-YYYY"}
                  onChange={(date, { customInput, isTyping }) => {
                    let input = document.getElementById("fromeDate-datepicker");

                    setFieldTouched("fromeDate", false);

                    if (!isTyping) {
                      if (_.isEmpty(date?.format())) {
                        return setFieldValue("fromeDate", "");
                      }

                      return setFieldValue("fromeDate", date.format()); // user selects the date from the calendar and no needs for validation.
                    }

                    if (!dateInputValidation(input, date)) {
                      return false;
                    }

                    setFieldValue("fromeDate", date?.format());
                  }}
                  dateFormat={dateFormats.datePickerFormat}
                  error={touched?.fromeDate && errors?.fromeDate}
                  errorMessage={errors?.fromeDate}
                />
                <FormikControl
                  variant="filled"
                  control="datepicker"
                  hiddenLabel
                  label={i18next.t("To date (inclusive)")}
                  id="toDate"
                  name="toDate"
                  value={values.dateOfAdmission}
                  placeholderText={i18next.t("Select To date")}
                  format={"DD-MM-YYYY"}
                  onChange={(date, { customInput, isTyping }) => {
                    let input = document.getElementById("toDate-datepicker");

                    setFieldTouched("toDate", false);

                    if (!isTyping) {
                      if (_.isEmpty(date?.format())) {
                        return setFieldValue("toDate", "");
                      }

                      return setFieldValue("toDate", date.format()); // user selects the date from the calendar and no needs for validation.
                    }
                    if (!dateInputValidation(input, date)) {
                      return false;
                    }

                    setFieldValue("toDate", date?.format());
                  }}
                  dateFormat={dateFormats.datePickerFormat}
                  error={touched?.toDate && errors?.toDate}
                  errorMessage={errors?.toDate}
                />
              </Box>
              <Box className={styles.buttonSectionWrapper}>
                <Box className={styles.buttonWrapper}>
                  <Button
                    title="Download data"
                    iconStyle={""}
                    buttonType="muibtn-primary"
                    withIcon={false}
                    attriType={"submit"}
                  />
                </Box>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default DealerExportForm;
